<template>
  <div class="app-news-index">
    <div class="app-news-index__actions">
      <div class="app-news-index__actions-tags">
        <div
          class="app-news-index__actions-tags-item"
          :class="{ active: +categoryId === category.id }"
          v-for="category in categories"
          :key="category.id"
          v-show="category.id !== 3 && category.id !== 2"
          @click="filterNews(category.id, true)"
        >
          {{ category.title }}
        </div>
      </div>
      <div class="app-news-index__actions-views">
        <app-button-control
          class="app-news-index__actions-link"
          route="/news"
          type="link"
          >Все новости</app-button-control
        >
      </div>
    </div>
    <div class="app-news-index__list">
      <div class="row app-news-index__row">
        <news-card
          v-for="news in lastNews"
          :key="news.id"
          :link="`/news/item/${news.id}`"
          :date="news.publishedAt"
          :title="news.header"
          :text="news.previewText"
          :image="news.previewPicture"
          :tags="news.categories"
          class="app-news-index__item"
          :class="{
            'col-3 col-md-4 col-sm-6 col-xxs-12': true,
          }"
        />
      </div>
    </div>

    <app-loader v-if="isLoading || isLoading" isCircle isAbsolute></app-loader>
  </div>
</template>

<script>
import { newsMapper } from '@/store/news';

export default {
  name: 'ViewNewsIndex',
  inject: ['responsive'],
  components: {
    NewsCard: () => import('@/pages/news/components/NewsCard'),
    AppLoader: () => import('@/components/ui/AppLoader'),
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
  },

  data: () => ({
    isLoading: false,
    categories: [],
    categoryId: 1,
  }),
  computed: {
    ...newsMapper.mapGetters(['lastNews']),
    ...newsMapper.mapState(['newsCategories']),
  },
  created() {
    this.asyncData();
  },
  methods: {
    ...newsMapper.mapActions(['getNews', 'getAllNewsCategories']),
    /**
     * стартовые данные
     */
    async asyncData() {
      this.isLoading = true;

      const data = {
        filter: {
          category: this.categoryId,
        },
        pagination: { offset: 0, limit: 4 },
      };
      try {
        await this.getNews(data);
        if (this.newsCategories.length === 0) {
          await this.getAllNewsCategories();
        }
        this.categories = this.categories.concat(this.newsCategories);
      } catch {
        //
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * Фильтрация новостей
     * @param {Number} id - id категории
     * @param {Boolean} start - нужна ли стартовая страница /1
     */
    async filterNews(id = null) {
      this.categoryId = id;
      const data = {
        pagination: { offset: 0, limit: 4 },
      };
      if (id) {
        data.filter = { category: id };
      }
      this.isLoading = true;
      try {
        await this.getNews(data);
      } catch {
        //
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.ViewHomeGuest__section {
  .app-news-index {
    &__item {
      &:nth-child(4) {
        @media only screen and (min-width: 1025px) and (max-width: 1369px) {
          display: none !important;
        }
      }
    }
  }
}
</style>
